module.exports = __webpack_public_path__ + "static/img/sy_wrj.0a6db4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/sy_wrj.png
// module id = Wnf/
// module chunks = 1